import moment from 'moment'
import 'daterangepicker'
import 'datetimepicker'

$(function () {
    'use strict'

    $('.input-daterange-timepicker').daterangepicker({
        timePicker: true,
        timePicker24Hour: true,
        locale: {
            format: 'DD/MM/YYYY HH:mm'
        }
    })

    $('.input-datetimepicker').daterangepicker({
      singleDatePicker: true,
      timePicker: true,
      timePicker24Hour: true,
      locale: {
        format: 'DD/MM/YYYY HH:mm'
      }
    })

    $(".input-datetimepicker").DateTimePicker({
      dateFormat: "dd-MM-yyyy",
      timeFormat: "HH:mm",
      dateTimeFormat: "dd-MM-yyyy HH:mm:ss AA"
    });

    $('.birthday-picker').daterangepicker({
      singleDatePicker: true,
      showDropdowns: true,
      minDate: moment('1936-01-01'),
      maxDate: moment().subtract(18, 'years'),
      locale: {
        format: 'DD-MM-YYYY'
      }
    })

    $('.datepicker').daterangepicker({
      singleDatePicker: true,
      locale: {
        format: 'DD-MM-YYYY'
      }
    })
})
